/**
 * M6.5-W11 — visuele cursor-cel voor het grid-based focus-model.
 *
 * Rendert een lege zwart-gestippelde rechthoek op de cursor-positie.
 * De grootte komt uit `data.size` (in flow-coords) zodat Canvas de
 * cursor-cel kan schalen op basis van de huidige zoom-level — de
 * gebruiker ziet altijd ongeveer dezelfde screen-grootte ongeacht
 * inzoomen.
 *
 * Geen interactie; alleen visueel. Gebruikt React Flow's node-pipeline
 * zodat 't automatisch meebeweegt met pan en zoom.
 */
import type { NodeProps } from "@xyflow/react";
import { CANVAS_CURSOR_CELL_SIZE } from "../../state/keymap";

/** Vaste node-id zodat we 'm in/uit kunnen schakelen zonder
 *  duplicate-ids te creëren. */
export const CURSOR_CELL_NODE_ID = "__ae_cursor_cell__";

export function CursorCellNode({ data }: NodeProps) {
  const d = data as { size?: number } | undefined;
  const size = d?.size ?? CANVAS_CURSOR_CELL_SIZE;
  return (
    <div
      className="pointer-events-none"
      style={{
        width: size,
        height: size,
        border: "3px dashed #000",
        boxSizing: "border-box",
        background: "rgba(255, 255, 255, 0.05)",
      }}
    />
  );
}
